interface Props {
	image: string;
	className?: string;
}

const CircuitiPagamentoCard: React.FC<Props> = (props) => {
	const { image, className } = props;

	return (
		<div className={"rounded-4 border circuiti-pagamento-card " + className}>
			<img src={image} />
		</div>
	);
};

export default CircuitiPagamentoCard;
